/**
 * Single source of truth for platform_id across all API calls.
 * Override via REACT_APP_PLATFORM_ID in .env-cmdrc.json if needed.
 */
export const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID || 'abode';

/** Chat API only — backend expects a separate platform id for chat. */
export const CHAT_PLATFORM_ID = 'abode_labs';

/** Profico platform id for auth / session / agent flows. */
export const PROFICO_PLATFORM_ID = 'profico';

/** Profico domain id for team flows. */
export const PROFICO_DOMAIN_ID = '86b04c9a-e9be-4ecc-a60e-dc8ddb44c5e8';

export default PLATFORM_ID;
